export default __webpack_public_path__ + "static/media/gif.46021fcb.svg";